import React from "react";
import { useAppSelector } from "../../../redux/store";
import FlightsTableHeader from "./FlightsTableHeader";
import FlightsTableBody from "./FlightsTableBody";

const FlightsTable = () => {
  const booking = useAppSelector((state) => state.booking);
  const flights = booking.bookingFlights;

  if (!flights || flights.length < 1) return null;

  return (
    <table className="table">
      <FlightsTableHeader />
      <FlightsTableBody />
    </table>
  );
};

export default FlightsTable;
